var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookmarkFilledIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33306 13.4702L3.81584 16.5103C3.37181 16.8945 2.74683 16.982 2.21524 16.736C1.68433 16.4891 1.34375 15.9538 1.34375 15.3642V2.6622C1.34375 1.82798 2.01387 1.15234 2.84108 1.15234H11.825C12.6522 1.15234 13.3224 1.82798 13.3224 2.6622V15.3642C13.3224 15.9538 12.9818 16.4891 12.4509 16.736C11.9193 16.982 11.2943 16.8945 10.8503 16.5103L7.33306 13.4702Z",
    fill: "#044B7F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkFilledIcon);
export default __webpack_public_path__ + "static/media/bookmark-filled-icon.2c6e9cbf42f65baf8bc44ba06cd34042.svg";
export { ForwardRef as ReactComponent };